import moment from "moment/moment";
import localStrings from "../localStrings";
import {
    byLocationMode,
    byPaymentMissingMode,
    byPaymentTypeMode,
    byProductMode,
    byProductTypeMode,
    byStaffMode
} from "./constants";
import {filterMonth, filterSingleDay, filterYear} from "../pages/Home/FilterInfoOverview";

const momenttz = require('moment-timezone')
export function getLastWeekStartDate() {
    return moment()
        .add(-7, 'days')
        .startOf('week')
        .format("YYYY-MM-DD");
}

export function getLastWeekEndDate() {
    return moment()
        .add(-7, 'days')
        .endOf('week')
        .format("YYYY-MM-DD");
}

export function getLastWeekDays() {
    let allDates = [];
    let initialDate = moment(getLastWeekStartDate());
    for (let i = 0; i < 7; i++) {
        allDates.push(moment(initialDate.add(1, 'days')));
    }
    return allDates;
}

export function getPrice(price) {
    return parseFloat(price.split(" ")[0]);
}

export function getCurrency(price) {
    return parseFloat(price.split(" ")[1]);
}

export function getOrderTotalPrice(order) {
    return (order.items || []).reduce((acc, item) => {
        return acc + getPrice(item.price) * item.quantity;
    }, 0);
}

export function getPricesOrderByHour(orders, dates, additionalFilter, getPriceOrderFunction) {
    let datas = [];
    dates.forEach(dateHour => {
        let total = orders.filter(order => {
            const dateHourOrder = moment(order.start_time_local).format("HH:00");
            return dateHourOrder === dateHour;
        })
            .filter(order => {
                if (!additionalFilter) {
                    return true;
                }
                return additionalFilter(order);
            })
            .reduce((acc, order) => {
                return acc + (getPriceOrderFunction ? getPriceOrderFunction(order) : getOrderTotalPrice(order));
            }, 0);
        datas.push(total);

    });
    return datas;
}

export function getOrderTotalQty(order) {
    return (order.items || []).reduce((acc, item) => acc + Number(item.quantity || 0), 0);
}

export function getQtyOrderByHour(orders, dates, additionalFilter, getQtyOrderFunction) {
    let datas = [];
    dates.forEach(dateHour => {
        let total = orders.filter(order => {
            const dateHourOrder = moment(order.start_time_local).format("HH:00");
            return dateHourOrder === dateHour;
        })
            .filter(order => {
                if (!additionalFilter) {
                    return true;
                }
                return additionalFilter(order);
            })
            .reduce((acc, order) => {
                return acc + (getQtyOrderFunction ? getQtyOrderFunction(order) : getOrderTotalQty(order));
            }, 0);
        datas.push(total);

    });
    return datas;
}

export function getTotalSerieByStaff(orders, dates, noPrice) {
    let series = {};
    let staffs = getStaffs(orders);
    staffs.forEach(staff => {
        series[staff] = {
            name: staff,
            data: noPrice ?
                getQtyOrderByHour(orders, dates, order => order.staff.staff_name === staff)
                :
                getPricesOrderByHour(orders, dates, order => order.staff.staff_name === staff)
        }
    })
    return Object.values(series);
}

export function getTotalSerieByLocation(orders, dates, noPrice) {
    let series = {};
    let locations = getlocations(orders);
    locations.forEach(location => {
        series[location] = {
            name: location || "Unknown",
            data: noPrice ?
                getQtyOrderByHour(orders, dates, order => order.location && order.location.location_name === location)
                :
                getPricesOrderByHour(orders, dates,
                        order =>  order.location && order.location.location_name === location)
        }
    })
    return Object.values(series);
}

export function buildProductCategoryMap(products, categories) {
    let map = {}
    products.forEach(product => {
        const category = categories.find(category => category.ref === product.category_id);
        if (!category) {
            return;
        }

        map[product.id] = category.id;
        (product.skus || []).forEach(sku => {
            map[sku.ref] = category.id;
        })
    })
    return map;
}

export function buildOptionOptionListMap(optionsList) {
    let map = {}
    optionsList.forEach(optionList => {
        optionList.options.forEach(option => {
            map[option.ref] = {
                name: option.name,
                optionListRef: optionList.ref,
                optionListName: optionList.name,
            };
        })
    })
    return map;
}

export function getOrderTotalPriceProduct(order, product) {
    const allRef = getAllProductRefs(product)
    return order.items.reduce((acc, item) => {

        if (allRef.includes(item.sku_ref)) {
            return acc + getPrice(item.price) * parseInt(item.quantity);
        }
        return acc;
    }, 0);
}

export function getOrderTotalQtyProduct(order, product) {
    const allRef = getAllProductRefs(product)
    return order.items.reduce((acc, item) => {

        if (allRef.includes(item.sku_ref)) {
            return acc +parseInt(item.quantity);
        }
        return acc;
    }, 0);
}

export function filterOrderItemsWithProduct(order, product) {
    let orderCopy = {...order}
    const allRef = getAllProductRefs(product)
    orderCopy.items = orderCopy.items.filter(item => {
        return allRef.includes(item.sku_ref)
    })
    if (orderCopy.items.length === 0) {
        return null;
    }
    return orderCopy;
}

export function filterOrderItemsWithStaff(order, staff) {
    let orderCopy = {...order}

    if (orderCopy.staff?.staff_ref === staff.id) {
        return orderCopy;
    }
    return null;
}

export function getOrderTotalPriceCategory(order, mapProductCategory, category, products) {
    return order.items.reduce((acc, item) => {
        if (!mapProductCategory[item.sku_ref]) {
            console.log(" !mapProductCategory")
            let product = products.find(product => product.id === item.sku_ref);
            console.log(" !mapProductCategory")
            product =  products.find(product => product.name.toUpperCase().trim() === item.product_name.toUpperCase().trim());
            console.log(" !mapProductCategory")
        }

        if (mapProductCategory[item.sku_ref] === category.id) {
            return acc + getPrice(item.price) * item.quantity;
        }
        return acc;
    }, 0);
}

export function getOrderTotalPricePaymentMode(order, paymentMode) {
    return (order.payments || []).reduce((acc, payment) => {
        if (payment.name === paymentMode) {
            return acc + getPrice(payment.amount);
        }
        return acc;
    }, 0);
}

export function getTotalSerieByProductType(orders, dates, products, categories, noPrice) {
    let series = {};

    const mapProductCategory = buildProductCategoryMap(products, categories);

    categories.forEach(category => {
        if (noPrice) {
            const qty = getQtyOrderByHour(orders, dates, null,
                order => getOrderTotalQtyProduct(order, products.find(product => product.category_id === category.id)))
            if (qty.filter(q => q > 0).length === 0) {
                return;
            }
            series[category.name] = {
                name: category.name,
                data: qty
            }
            return;
        }
        else {
            const price = getPricesOrderByHour(orders, dates, null,
                order => getOrderTotalPriceCategory(order, mapProductCategory, category, products))
            if (price.filter(p => p > 0).length > 0) {
                series[category.name] = {
                    name: category.name,
                    data: price
                }
            }
        }
    })
    return Object.values(series);
}

export function getTotalSerieByPaymentType(orders, dates) {
    let series = {};
    let paymentModes = getPaymentModes(orders);

    paymentModes.forEach(paymentMode => {
        const price = getPricesOrderByHour(orders, dates, null,
            order => getOrderTotalPricePaymentMode(order, paymentMode))
        if (price.filter(p => p > 0).length > 0) {
            series[paymentMode] = {
                name: paymentMode,
                data: price
            }
        }
    })
    return Object.values(series);
}

export function getTotalSerieGlobal(orders, dates, noPrice) {
    return {
        turnover: {
            name: noPrice ? localStrings.quantity : localStrings.turnover,
            data: noPrice ? getQtyOrderByHour(orders, dates) : getPricesOrderByHour(orders, dates)
        }
    }
}

export function getProductTotalSerieGlobal(orders, dates, product, noPrice) {
    return {
        turnover: {
            name: noPrice ? localStrings.quantity : localStrings.turnover,
            data: noPrice ?
                getQtyOrderByHour(orders, dates, null, order => getOrderTotalQtyProduct(order, product))
                :
                getPricesOrderByHour(orders, dates, null,
                order => getOrderTotalPriceProduct(order, product))
        }
    }
}

function getDiffPayment(order) {
    const diff = -getOrderTotalPrice(order) + (order.payments || []).reduce((acc, payment) => {
        return acc + getPrice(payment.amount);
    }, 0);
    return diff;
}

export function getMissingTotalSerieGlobal(orders, dates) {
    let series = [];
    let staffs = getStaffs(orders);
    staffs.forEach(staff => {
        series[staff] = {
            name: staff,
            data:
                getPricesOrderByHour(orders, dates,
                    order => order.staff.staff_name === staff,
                    getDiffPayment)
        }
    })
    return Object.values(series);

}

export function getStaffs(orders) {
    let staffs=[];
    (orders || []).forEach(order => {
        if (order.staff) {
            if (!staffs.includes(order.staff.staff_name)) {
                staffs.push(order.staff.staff_name)
            }
        }
    })
    return staffs;
}

export function getPaymentModes(orders) {
    let payments=[];
    (orders || []).forEach(order => {
        (order.payments || []).forEach(payment => {
            if (!payments.includes(payment.name)) {
                payments.push(payment.name)
            }
        })
    })
    return payments;
}

export function getlocations(orders) {
    let locations=[];
    (orders || []).forEach(order => {
        if (order.location) {
            if (!locations.includes(order.location.location_name)) {
                locations.push(order.location.location_name)
            }
        }
    })
    return locations;
}

export function getProductsCategories(orders) {
    let locations=[];
    (orders || []).forEach(order => {
        if (order.location) {
            if (!locations.includes(order.location.location_name)) {
                locations.push(order.location.location_name)
            }
        }
    })
    return locations;
}

export function getCategoryIds(categories) {
    return categories.map(category => category.id);
}

export function getAllProductRefs(product) {
    return [product.ref, ...(product.skus.map(sku => sku.ref))];
}

export function getAllProductNames(product) {
    return [product.name, ...(product.skus.map(sku => sku.name))];
}

export function getTotalInfoByProduct(product, orders) {
    const allRef = getAllProductRefs(product);
    let total = 0;
    let count = 0;
    orders.forEach(order => {
        order.items.forEach(item => {
            if (allRef.includes(item.sku_ref)) {
                total += getPrice(item.price) * item.quantity;
                count += parseInt(item.quantity);
            }
        })
    })
    return {
        total: total,
        count: count,
    };
}

export function getTotalInfoByStaff(staff, orders) {
    let total = 0;
    let count = 0;
    orders.forEach(order => {
        if (order.staff?.staff_ref === staff.id) {
            order.items.forEach(item => {
                total += getPrice(item.price) * item.quantity;
                count += parseInt(item.quantity);
            })
        }
    });

    return {
        total: total,
        count: count,
    };
}



export function getTotalInfoBySumUpDayByProduct(product, sumUpDay) {
    const allRef = getAllProductRefs(product);
    const allNames = getAllProductNames(product);
    let total = 0;
    let count = 0;
    const keysStaffs = Object.keys(sumUpDay.detailbyStaff);
    keysStaffs.forEach(staffId => {
            const detail = sumUpDay.detailbyStaff[staffId];
            Object.keys(detail.locations).forEach(locationId => {
                const location = detail.locations[locationId];
                Object.keys(location.products.timeSlot).forEach(timeSlot => {

                    const timeSlotData = location.products.timeSlot[timeSlot];
                    Object.keys(timeSlotData).forEach(productRef => {
                        if (allRef.includes(productRef) || productRef === product.ref) {
                            total += timeSlotData[productRef].totalPrice;
                            count += timeSlotData[productRef].quantity;
                        }
                        else if (allNames.includes(productRef) || productRef === product.name) {
                            total += timeSlotData[productRef].totalPrice;
                            count += timeSlotData[productRef].quantity;
                        }
                    })
                });
            });

        }
    );
    return {
        total: total,
        count: count,
    };
}

export function getTotalInfoBySumUpDayByStaff(staff, sumUpDay) {
    // const allRef = getAllProductRefs(product);
    let total = 0;
    let count = 0;

    let detailbyStaffElement = sumUpDay.detailbyStaff[staff.id];
    if (!detailbyStaffElement) {
        detailbyStaffElement = sumUpDay.detailbyStaff[staff.name]
    }

    if (detailbyStaffElement) {
        Object.keys(detailbyStaffElement.locations).forEach(locationId => {
            const location = detailbyStaffElement.locations[locationId];
            Object.keys(location.products.timeSlot).forEach(timeSlot => {

                const timeSlotData = location.products.timeSlot[timeSlot];
                Object.keys(timeSlotData).forEach(productRef => {
                    total += timeSlotData[productRef]?.totalPrice || 0;
                    count += timeSlotData[productRef]?.quantity || 0;
                })
            });
        });
    }

    return {
        total: total,
        count: count,
    };
}

function getNameByStaffId(staffId, staffs) {
    return (staffs || []).find(staff => staff.id === staffId)?.name;
}

function getNameByLocationId(locationId, locations) {
    return (locations || []).find(location => location.id === locationId)?.name;
}

function getNameByPaymentModeId(paymentModeId, paymentModes) {
    return (paymentModes || []).find(paymentMode => paymentMode.id === paymentModeId)?.name;
}

export function getSerieDataByLocation(sumupDaysDetail, series, product, locations, sumUpDays,
                                       useNamedData = false, noPrice) {
    let allLocations = [];
    sumupDaysDetail.forEach(sumUpDay => {
        if (!sumUpDay.detailbyStaff) {
            return;
        }
        const staffIds = Object.keys(sumUpDay.detailbyStaff);
        staffIds.forEach(staffId => {
            const locationId = Object.keys(sumUpDay.detailbyStaff[staffId].locations);
            locationId.forEach(locationId => {
                if (!allLocations.includes(locationId)) {
                    allLocations.push(locationId);
                }
            })
        })
    })

    allLocations.forEach(locationId => {
        series.push({
            name: useNamedData ? locationId : getNameByLocationId(locationId, locations),
            data: sumupDaysDetail.map(sumUpDay => {
                if (!product) {
                    if (!sumUpDay.detailbyStaff) {
                        return 0;
                    }
                    const staffIds = Object.keys(sumUpDay.detailbyStaff);
                    let grandTotal = 0;
                    staffIds.forEach(staffId => {
                        if (sumUpDay.detailbyStaff[staffId].locations[locationId]) {
                            grandTotal += sumUpDay.detailbyStaff[staffId].locations[locationId].totalTurnover;
                        }
                    })
                    return grandTotal;
                }
                var total = 0;
                iterateSumUpDayProducts(sumUpDay, (productRef, productData) => {
                    if (productRef === product.ref) {
                        total += noPrice ? productData.quantity : productData.totalPrice;
                    }
                    else if (product.name && productRef === product.name) {
                        total += noPrice ? productData.quantity : productData.totalPrice;
                    }
                }, null, locationId)
                return total;
            })
        })

    });

    return {
        dates: sumUpDays.map(sumUpDay => sumUpDay.dayDate),
        series: series
    }
}



export function getSerieDatabyProductTypeMode(sumupDaysDetail, series, products, categories, sumUpDays) {
    let allCategories = [];
    if (!products) {
        return null;
    }

    sumupDaysDetail.forEach(sumUpDay => {
        if (!sumUpDay.detailbyStaff) {
            return;
        }

        const staffIds = Object.keys(sumUpDay.detailbyStaff);
        staffIds.forEach(staffId => {
            const dataStaff = sumUpDay.detailbyStaff[staffId];
            const locations = Object.keys(dataStaff.locations);
            locations.forEach(location => {
                var timeSlots= dataStaff.locations[location].products.timeSlot;
                var keysTimeSlots = Object.keys(timeSlots);
                keysTimeSlots.forEach(keyTimeSlot => {
                    var productsData = timeSlots[keyTimeSlot];
                    const productsKeys = Object.keys(productsData);
                    productsKeys.forEach(product => {
                        var productDef = products.find(productDef => productDef.ref === product);
                        if (!productDef) {
                            productDef = products.find(productDef => productDef.name === product);
                        }
                        if (productDef && !allCategories.includes(productDef.category_id)) {
                            allCategories.push(productDef.category_id);
                        }
                    })
                })
            });
        })
    });

    allCategories.forEach(categoryId => {
        var categoryName = categories.find(category => category.ref === categoryId).name;
        series.push({
            name: categoryName || categoryId,
            data: sumupDaysDetail.map(sumUpDay => {
                if (!sumUpDay.detailbyStaff) {
                    return 0;
                }


                let grandTotal = 0;
                const staffIds = Object.keys(sumUpDay.detailbyStaff);
                staffIds.forEach(staffId => {
                    const dataStaff = sumUpDay.detailbyStaff[staffId];
                    const locations = Object.keys(dataStaff.locations);
                    locations.forEach(location => {
                        var timeSlots= dataStaff.locations[location].products.timeSlot;
                        var keysTimeSlots = Object.keys(timeSlots);
                        keysTimeSlots.forEach(keyTimeSlot => {
                            var productsData = timeSlots[keyTimeSlot];
                            const productsKeys = Object.keys(productsData);
                            productsKeys.forEach(product => {
                                var productDef = products.find(productDef => productDef.ref === product);
                                if (!productDef) {
                                    productDef = products.find(productDef => productDef.name === product);
                                }
                                if (productDef && productDef.category_id === categoryId) {
                                    grandTotal += productsData[product].totalPrice;
                                }
                            })
                        })
                    });
                })
                return grandTotal;
            })
        })

    })

    return {
        dates: sumUpDays.map(sumUpDay => sumUpDay.dayDate),
        series: series
    }

}

function getSerieDataByPaymentType(sumupDaysDetail, series, paymentModes, sumUpDays) {
    let allPaymentModes = [];
    sumupDaysDetail.forEach(sumUpDay => {
        if (!sumUpDay.detailbyStaff) {
            return;
        }
        const staffIds = Object.keys(sumUpDay.detailbyStaff);
        staffIds.forEach(staffId => {
            const data = sumUpDay.detailbyStaff[staffId];
            if (!data.payments) {
                return;
            }
            const payments = Object.keys(data.payments)
            payments.forEach(payment => {
                if (!allPaymentModes.includes(payment)) {
                    allPaymentModes.push(payment);
                }
            })
        })
    })

    allPaymentModes.forEach(paymentMode => {
        series.push({
            name: getNameByPaymentModeId(paymentMode, paymentModes),
            data: sumupDaysDetail.map(sumUpDay => {
                if (!sumUpDay.detailbyStaff) {
                    return 0;
                }
                const staffIds = Object.keys(sumUpDay.detailbyStaff);
                let grandTotal = 0;
                staffIds.forEach(staffId => {
                    if (sumUpDay.detailbyStaff[staffId].payments && sumUpDay.detailbyStaff[staffId].payments[paymentMode]) {
                        grandTotal += sumUpDay.detailbyStaff[staffId].payments[paymentMode].totalPrice;
                    }
                })
                return grandTotal;
            })
        })

    });

    return {
        dates: sumUpDays.map(sumUpDay => sumUpDay.dayDate),
        series: series
    }
}

function getSerieDatabyPaymentMissingMode(sumupDaysDetail, series, staffs, paymentModes, sumUpDays) {
    let allStaffs = [];
    sumupDaysDetail.forEach(sumUpDay => {
        if (!sumUpDay.detailbyStaff) {
            return;
        }
        const staffIds = Object.keys(sumUpDay.detailbyStaff);
        staffIds.forEach(staffId => {
            if (!allStaffs.includes(staffId)) {
                allStaffs.push(staffId);
            }
        })
    })

    allStaffs.forEach(staffId => {
        series.push({
            name: getNameByStaffId(staffId, staffs),
            data: sumupDaysDetail.map(sumUpDay => {
                if (!sumUpDay.detailbyStaff) {
                    return 0;
                }
                let detail = sumUpDay.detailbyStaff[staffId];
                if (!detail) {
                    return 0;
                }
                var totalProduct = 0;
                var totalPaid = 0;
                if (detail && detail.totalTurnover) {
                    totalProduct = detail.totalTurnover;
                }
                if (detail.payments) {
                    const paymentsKeys = Object.keys(detail.payments);
                    paymentsKeys.forEach(paymentKey => {
                        totalPaid += detail.payments[paymentKey].totalPrice;
                    })
                }
                else {
                    totalPaid = 0;
                }

                return totalPaid - totalProduct;
            })
        })
    });


    return {
        dates: sumUpDays.map(sumUpDay => sumUpDay.dayDate),
        series: series
    }
}


function getSerieDataByStaff(sumupDaysDetail, series, product, staffs, sumUpDays, useNamedData = false, noPrice) {
    let allStaffs = [];
    let allRef = null;
    let allNames = null;
    if (product) {
        allRef = getAllProductRefs(product);
        allNames = getAllProductNames(product);
    }

    sumupDaysDetail.forEach(sumUpDay => {
        if (!sumUpDay.detailbyStaff) {
            return;
        }
        const staffIds = Object.keys(sumUpDay.detailbyStaff);
        staffIds.forEach(staffId => {
            if (!allStaffs.includes(staffId)) {
                allStaffs.push(staffId);
            }
        })
    })

    allStaffs.forEach(staffId => {
        series.push({
            name: useNamedData ? staffId : getNameByStaffId(staffId, staffs),
            data: sumupDaysDetail.map(sumUpDay => {
                if (!product) {
                    if (!sumUpDay.detailbyStaff) {
                        return 0;
                    }
                    let detail = sumUpDay.detailbyStaff[staffId];
                    if (detail && detail.totalTurnover) {
                        return detail.totalTurnover;
                    }
                    return 0;
                }
                var total = 0;
                iterateSumUpDayProducts(sumUpDay, (productRef, productData) => {
                    if (allRef.includes(productRef)) {
                        total += noPrice ? productData.quantity : productData.totalPrice;
                    }
                    else if (allNames.includes(productRef)) {
                        total += noPrice ? productData.quantity : productData.totalPrice;
                    }
                }, staffId)
                return total;

            })
        })

    });

    return {
        dates: sumUpDays.map(sumUpDay => sumUpDay.dayDate),
        series: series
    }
}

export function getDataWeekOrMonth(sumUpDays, displayMode, products, staffs, paymentModes, locations,
                                   categories, product, timezone, additionalFilters, transformer,
                                   transformerSumUpDay, serieBuilerSumUpDay, filterType, noPrice) {

    let sumupDaysDetail = sumUpDays.map(sumUpDay => {
        try {
            return JSON.parse(sumUpDay.content)
        }
        catch (e) {
            return {}
        }
    })

    let series = [];

    if (displayMode === byStaffMode) {
        return getSerieDataByStaff(sumupDaysDetail, series, product, staffs, sumUpDays,
            false, noPrice);
    }

    else if (displayMode === byLocationMode) {
        return getSerieDataByLocation(sumupDaysDetail, series, product, locations, sumUpDays,
            false, noPrice);
    }

    else if (displayMode === byPaymentTypeMode) {
        return getSerieDataByPaymentType(sumupDaysDetail, series, paymentModes, sumUpDays);
    }

    else if (displayMode === byProductTypeMode) {
        return getSerieDatabyProductTypeMode(sumupDaysDetail, series, products, categories, sumUpDays);
    }

    else if (displayMode === byPaymentMissingMode) {
        return getSerieDatabyPaymentMissingMode(sumupDaysDetail, series, staffs, paymentModes, sumUpDays);
    }

    if (transformerSumUpDay) {
        sumupDaysDetail = sumupDaysDetail.map(transformerSumUpDay);
    }

    if (serieBuilerSumUpDay) {
        return serieBuilerSumUpDay(sumupDaysDetail, series, products, categories, sumUpDays, noPrice);
    }


    series.push({
        name: "Total",
        data: sumupDaysDetail.map(sumUpDay => {

            if (!product) {
                return sumUpDay?.totalTurnover || 0
            }
            const allRef = getAllProductRefs(product);
            const allNames = getAllProductNames(product);
            var total = 0;

            if (noPrice) {
                iterateSumUpDayProducts(sumUpDay, (productRef, productData) => {
                    if (allRef.includes(productRef)) {
                        total += productData.quantity;
                    }
                    else if (allNames.includes(productRef)) {
                        total += productData.quantity;
                    }
                })
            }
            else {
                iterateSumUpDayProducts(sumUpDay, (productRef, productData) => {
                    if (allRef.includes(productRef)) {
                        total += productData.totalPrice;
                    }
                    else if (allNames.includes(productRef)) {
                        total += productData.totalPrice;
                    }
                })
            }


            return total;
        })
    })

    return {
        dates: sumUpDays.map(sumUpDay => sumUpDay.dayDate),
        series: series
    }

}

export function iterateSumUpDayProducts(sumUpDay,  processProductcallback, staffIdParam, locationIdParam) {
    if (!sumUpDay.detailbyStaff) {
        return;
    }
    const keysStaffs = Object.keys(sumUpDay.detailbyStaff);
    keysStaffs.forEach(staffId => {
            if (staffIdParam && staffId !== staffIdParam) {
                return;
            }

            const detail = sumUpDay.detailbyStaff[staffId];
            Object.keys(detail.locations).forEach(locationId => {
                const location = detail.locations[locationId];
                Object.keys(location.products.timeSlot).forEach(timeSlot => {
                    if (locationIdParam && locationId !== locationIdParam) {
                        return;
                    }
                    const timeSlotData = location.products.timeSlot[timeSlot];
                    Object.keys(timeSlotData).forEach(productRef => {
                        processProductcallback(productRef, timeSlotData[productRef]);
                    })
                });
            });

        }
    );
}

export function getDataSingleDay(orders, displayMode, products, categories, product,
                                 timezone, additionalFilters, transformer, serieBuiler, noPrice) {

    if (!orders || orders.length === 0) {
        return null;
    }

    orders.sort((a, b) => {
        return a.start_time_local.localeCompare(b.start_time_local);
    })

    const firstOrder = orders[0];
    const lastOrder = orders[orders.length - 1];

    const firstOrderDate = moment(firstOrder.start_time_local);
    const lastOrderDate = moment(lastOrder.start_time_local);

    const diffHours = lastOrderDate.diff(firstOrderDate, 'hours');

    const firstHour = parseInt(firstOrderDate.format("HH"));

    let dates =[]
    let series =[]

    for (let i = firstHour; i <= firstHour + diffHours + 1; i++) {
        const dateHour = String(i % 24).padStart(2, '0') + ":00";
        dates.push(dateHour);
    }

    if (additionalFilters && additionalFilters.length > 0) {
        additionalFilters.forEach(filter => {
            orders = orders.filter(filter);
        });
    }

    if (transformer) {
        let newOrders = [];
        orders = orders.map(order => {
            const orderTransformed = transformer(order);
            if (orderTransformed) {
                newOrders.push(orderTransformed);
            }
        })
        orders = newOrders;
    }

    if (serieBuiler) {
        series = serieBuiler(orders, dates);
    }


    else if (displayMode === byStaffMode) {
        series = series.concat(Object.values(getTotalSerieByStaff(orders, dates, noPrice)))
    }
    else if (displayMode === byProductTypeMode && products && categories) {
        series = series.concat(Object.values(getTotalSerieByProductType(orders, dates, products, categories, noPrice)))
    }
    else if (displayMode === byLocationMode) {
        series = series.concat(Object.values(getTotalSerieByLocation(orders, dates, noPrice)))
    }
    else if (displayMode === byPaymentTypeMode &&  !noPrice) {
        series = series.concat(Object.values(getTotalSerieByPaymentType(orders, dates)))
    }
    else if (displayMode === byPaymentMissingMode && !noPrice) {
        series = series.concat(Object.values(getMissingTotalSerieGlobal(orders, dates)));
    }
    else if (displayMode === byProductMode) {
        series = series.concat(Object.values(getProductTotalSerieGlobal(orders, dates, product, noPrice)));
    }
    else if (!displayMode) {
        series = series.concat(Object.values(getTotalSerieGlobal(orders, dates, noPrice)));
    }

    return {
        dates: dates,
        series: series
    }

    // return Object.values(dataRet);
}